/**
 * Determines if there was a change in the provided Angular simple change.
 * @remarks This function includes the first change.
 * @param change Angular's simple change to be evaluated.
 * @returns `true` if a change has taken place; otherwise `false`.
 */
function didChange(change) {
    return !!change && change.previousValue !== change.currentValue;
}
/**
 * Determines if there was a change in the provided Angular simple change.
 * @remarks This function does not include the first change.
 * @param change Angular's simple change to be evaluated.
 * @returns `true` if a change has taken place; otherwise `false`.
 */
function didChangeAfterFirst(change) {
    return didChange(change) && !change.isFirstChange();
}

/**
 * Generated bundle index. Do not edit.
 */

export { didChange, didChangeAfterFirst };
